/**
 * L'ORDRE DU GROUPE « EPINGLEES » (R12, ecart M de la verification) : le meme
 * dans la fenetre de communication et dans l'app Canaux, pour une meme source
 * (les epingles personnelles du socle). D'abord le TYPE, dans l'ordre des
 * groupes de la fenetre (Lia, canal, direct, fiche), puis l'ordre
 * d'epinglage. Une seule fonction, pour qu'aucun ecran ne trie a sa facon.
 */
export type GenreDEpingle = 'lia' | 'canal' | 'direct' | 'fiche';

export const ORDRE_DES_GENRES_EPINGLES: readonly GenreDEpingle[] = ['lia', 'canal', 'direct', 'fiche'];

export function ordreDesEpinglees<T>(
  elements: readonly T[],
  genreDe: (element: T) => GenreDEpingle,
  refDe: (element: T) => string,
  epinglees: readonly string[],
): T[] {
  const rang = (element: T): number => {
    const r = epinglees.indexOf(refDe(element));
    return r === -1 ? Number.MAX_SAFE_INTEGER : r;
  };
  return elements
    .map((element, index) => ({ element, index }))
    .sort((a, b) => ORDRE_DES_GENRES_EPINGLES.indexOf(genreDe(a.element)) - ORDRE_DES_GENRES_EPINGLES.indexOf(genreDe(b.element))
      || rang(a.element) - rang(b.element) || a.index - b.index)
    .map(({ element }) => element);
}
